import {
  ArticleDetailPageContext,
  TrackingProduct,
  TrackingProductCategory,
  TrackingStreamSectionContext,
} from '../../../types';
import {getCategory} from '../helpers/category';
import {
  DataLayerProductGA3,
  DataLayerProductGA4,
  EventPageData,
  TrackingClientStateHolder,
} from '../helpers/clientState';
import {shouldPushToDataLayerObject} from '../helpers/datalayer';
import {
  MappedDimensionsProduct,
  ProductTrackingContextType,
  getStateFullDataLayerProduct,
} from '../helpers/product';
import {getSourceSortChannel} from '../helpers/sortChannel';
import {trackContentView} from './trackContentView';

export interface DetailPageEventGA3 {
  event: 'detailPage';
  ecommerce: {
    detail: {
      actionField: {
        action: 'detail';
      };
      products: MappedDimensionsProduct<DataLayerProductGA3>[];
    };
  };
}

export interface DetailPageEventGA4 extends EventPageData {
  event: 'view_item';
  ecommerce: {
    items: DataLayerProductGA4[];
  };
}
export interface DetailPageEvent {
  GA4: DetailPageEventGA4;
}

export const trackAdpView =
  ({
    page,
    product,
    productCategories,
    customElementAndSection,
  }: {
    page: ArticleDetailPageContext;
    product: TrackingProduct;
    productCategories: TrackingProductCategory[];
    customElementAndSection?: ProductTrackingContextType;
  }) =>
  (clientState: TrackingClientStateHolder): DetailPageEvent => {
    let currentState = clientState.getCurrent();

    // Added here a part of new tab ADP logic
    // problem is that we are not taking origin click unless we force it.
    clientState.update({
      originClick:
        (
          (customElementAndSection?.section as TrackingStreamSectionContext) ||
          {}
        ).recoType || ' ',
    });

    const category = getCategory({
      productCategories,
      state: currentState,
    });

    shouldPushToDataLayerObject(
      trackContentView({
        page,
      })(clientState),
      clientState
    );
    currentState = clientState.getCurrent();

    const sortChannel = getSourceSortChannel(currentState);

    const elementAndSection = customElementAndSection
      ? {
          element: customElementAndSection.element,
          section: customElementAndSection.section,
        }
      : {
          element: undefined,
          section: undefined,
        };

    const {product: productGA} = getStateFullDataLayerProduct({
      currentState,
      product,
      sortChannel,
      ...(elementAndSection as ProductTrackingContextType),
      category,
      productUnitPrice: product.unitPrice,
    });

    const eventGA4: DetailPageEventGA4 = {
      event: 'view_item',
      content_name: page?.path,
      page_type: page?.type,
      page_type_id: page?.id?.toString() || '',
      ecommerce: {
        items: [productGA],
      },
    };
    const event = {
      GA4: eventGA4,
    };

    return event;
  };
